export default __webpack_public_path__ + "static/media/twitter.c0fc520f.svg";